import {useState } from 'react';
import { Form, InputGroup, ListGroup } from "react-bootstrap";


const getProducts = (products, goodsSearch, goodsCode) => {
  if(!goodsSearch) {
    return [];
  }
  return products.filter( (obj) => {
      if(goodsSearch) {
          if((obj.GoodsCode).toLowerCase().split((goodsSearch).toLowerCase()).length - 1 > 0) {
              return true;
          }
          if((obj.GoodsName).toLowerCase().split((goodsSearch).toLowerCase()).length - 1 > 0) {
            return true;
        }
      } else {
          return true;
      }
  });
}

const ProductSearchComponent = ({products, goodsCode, handleChangeGoodsCode, handleSelectGoodsCode}) => {

  const [goodsSearch, setGoodsSearch] = useState('');

  if(
    typeof products === "undefined" ||
    typeof goodsCode === "undefined" || 
    typeof handleChangeGoodsCode !== "function" ||
    typeof handleSelectGoodsCode !== "function") {
    return <></>
  }

  return (
    <>
    <Form>
    <Form.Group className="mb-3" controlId="formProductName">
        <div>
            <span className="font-weight-bold">Product Search</span>
        </div>
        <InputGroup className="mt-2">
        <Form.Control 
            type="text"
            placeholder={!goodsSearch && goodsCode ? goodsCode : "Enter product code or name"}
            onChange={(e) => {
              setGoodsSearch(e.currentTarget.value);
            }}
            value={goodsSearch ? goodsSearch.toUpperCase() : ""}
        />
        {(goodsSearch || goodsCode) &&
        <InputGroup.Text 
          className="is-hover" 
          onClick={ () => {
            setGoodsSearch(''); 
            handleChangeGoodsCode();
          }}>
            Clear
        </InputGroup.Text>
        }
        </InputGroup>
    </Form.Group>
    </Form>
    <div className="list-group-container">
      {
       getProducts(products, goodsSearch, goodsCode).map( (product) => {
          return (
           <ListGroup.Item
           href={`#${product.GoodsCode}`}
           onClick={ () => {
            setGoodsSearch(product.GoodsCode); 
            handleSelectGoodsCode(product.GoodsCode, product.GoodsId);
          }}
           className="is-hover"
           active={product.GoodsCode === goodsCode}
           >
               ({product.GoodsCode}) {product.GoodsName}
           </ListGroup.Item>            
          );
       })      
      }
    </div> 
    </>     
  )
}

export default ProductSearchComponent